import { useState } from "react";
import { Accordion, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Helpdesk({permission, setactivity, activeItem}) {
  const [isProductionOpen, setProductionOpen] = useState(true); // Predeterminadamente abierto
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };
 
 
  return (
    <Accordion.Item eventKey="5">
    <Accordion.Header>
      <span role="img" aria-label="projects">🐸</span> HelpDesk {permission==='1'&&('👑')}
    </Accordion.Header>
    <Accordion.Body className="p-0">
      <Nav className="flex-column">
        <Nav.Link active={activeItem === 'helpdesk'} style={activeItem === 'helpdesk' ? activeStyles : undefined} onClick={() => navigate('/helpdesk')}>Helpdesk</Nav.Link>
        <Nav.Link active={activeItem === 'helpdesk_report'} style={activeItem === 'helpdesk_report' ? activeStyles : undefined} onClick={() => navigate('/helpdesk_report')}>Helpdesk Report </Nav.Link>
      </Nav>
    </Accordion.Body>
  </Accordion.Item>
    
  );
}

export default Helpdesk;
